import type { ApiClient } from './client.js';
import type { AddLinkBody, LinkDto, ReorderLinksBody } from './types.js';

/**
 * Links client: a classroom's curated list of web links (built before class,
 * opened one at a time during the day). Mirrors the YouTube playlist API.
 */
export interface LinksApi {
  listLinks(classroomId: string): Promise<LinkDto[]>;
  addLink(classroomId: string, body: AddLinkBody): Promise<LinkDto>;
  removeLink(classroomId: string, linkId: string): Promise<void>;
  reorderLinks(classroomId: string, body: ReorderLinksBody): Promise<LinkDto[]>;
}

export function createLinksApi(client: ApiClient): LinksApi {
  return {
    async listLinks(classroomId) {
      const res = await client.get<{ links: LinkDto[] }>(`/api/classrooms/${classroomId}/links`);
      return res.links;
    },
    async addLink(classroomId, body) {
      const res = await client.post<{ link: LinkDto }>(
        `/api/classrooms/${classroomId}/links`,
        body,
      );
      return res.link;
    },
    async removeLink(classroomId, linkId) {
      await client.delete(`/api/classrooms/${classroomId}/links/${linkId}`);
    },
    async reorderLinks(classroomId, body) {
      const res = await client.put<{ links: LinkDto[] }>(
        `/api/classrooms/${classroomId}/links/reorder`,
        body,
      );
      return res.links;
    },
  };
}
